import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import {connectRouter} from 'connected-react-router';
import {history, middlewares} from './config';
import authDuck from './authDuck';
import commonDuck from './commonDuck';
import quickDuck from './quickDuck';
import deepDuck from './deepDuck';
import seguimientoDuck from './seguimientoDuck';

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    [authDuck.store]: authDuck.reducer,
    [commonDuck.store]: commonDuck.reducer,
    [quickDuck.store]: quickDuck.reducer,
    [deepDuck.store]: deepDuck.reducer,
    [seguimientoDuck.store]: seguimientoDuck.reducer
  });

const generateStore = () => {
  const store = createStore(
    rootReducer(history),
    compose(applyMiddleware(...middlewares))
  );
  if (module.hot) {
    module.hot.accept('./', () => {
      store.replaceReducer(rootReducer(history));
    });
  }

  return store;
};

export default generateStore;
